import { render, staticRenderFns } from "./amortisasi.vue?vue&type=template&id=70497d5c&scoped=true&"
import script from "./amortisasi.vue?vue&type=script&lang=js&"
export * from "./amortisasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70497d5c",
  null
  
)

export default component.exports